module.exports = __webpack_public_path__ + "static/media/04_theemperor.776296a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/04_theemperor.png
// module id = 67
// module chunks = 0